import React from "react";

function Details({item}) {
    return (
        <div dangerouslySetInnerHTML={{ __html: item?.Details }} />
    );
}

export default Details;